import React from "react";
import Form_Header from "../../../common/form-header/Form_Header";
import "./Success_Page.css";
import { Registration_Lottie } from "../../../lotties/registration-lottie/Registration_Lottie";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import { useNavigate } from "react-router-dom";

const Success_Page = () => {
  const navigate = useNavigate();
  return (
    <section className="success_page step1_wrapper step3_wrapper">
      <Form_Header step={6} totalSteps={6} />
      <div className="container">
        <div className="success_lottie_holder">
          <div className="success_lottie_text_holder">
            <h2 className="registration">Registration Done Successfully!</h2>
            <p className="success_text">
              We will notify you within 24 hours via Email & Message with
              Confirmation link or, if arises any query.
            </p>
            <p className="success_subtext">Have a Fine Time Ahead!</p>
          </div>
          <div className="lottie_holder">
            <Registration_Lottie />
          </div>
        </div>

        <div className="form_btn_holder">
          <Common_Btn btnText="Got it" onClick={() => navigate("/home")} />
        </div>
      </div>
    </section>
  );
};

export default Success_Page;
